// Single source for the current Terms of Service / Privacy Policy version —
// referenced both by the legal pages themselves (displayed "Last updated")
// and by every place that records a user's consent (AuthModal.jsx,
// ForcePasswordChangeModal.jsx, AuthContext.jsx), so a future content update
// only ever needs this one value bumped.
export const LEGAL_VERSION = '2026-08-22';
export const LEGAL_EFFECTIVE_DATE_DISPLAY = 'August 22, 2026';
